module.exports = {
  title: 'Crypto Tracker',
  description: `
    I've become fascinated by cryptocurrencies recently (who hasn't, right?) and decided it'd be another fun little project to try and make a simple price tracker.
    I decided to take a stab at learning the websocket API and integrating it with React+Redux+Observables.
  `,
  tags: ['CSS', 'Design', 'React', 'Redux', 'Redux-Observable', 'WebSocket'],
  images: [require('./images/1.png')],
  url: 'http://crypto.christieman.com/',
};



// WEBPACK FOOTER //
// ./src/data/works/crypto/index.js